export class DinamicData {

    constructor(
        public headers: Array<string> = [],
        public rows: Array<Array<Cell>> = []
    ) {}
}

export class Cell {

    private type: string;
    private typeaction: string;
    private class: string;
    private style: string;
    private td_class: string;
    private td_style: string;
    private icon: string;
    private color: string;
    private title: string;
    private tooltip: string;
    public grayed: boolean;
    public selected: boolean;
    private checkboxFieldWidth: string;

    constructor(
        public value: any,
        config: any = {}
    ) {
        this.type = config.type && (typeof config.type === 'string' || config.type instanceof String) ? config.type : 'txt';
        this.typeaction = config.typeaction && (typeof config.typeaction === 'string' || config.typeaction instanceof String) ? config.typeaction : '';

        this.class = config.class && (typeof config.class === 'string' || config.class instanceof String) ? config.class : '';
        this.style = config.style || '';
        this.td_class = config.td_class && (typeof config.td_class === 'string' || config.td_class instanceof String) ? config.td_class : '';
        this.td_style = config.td_style && (typeof config.td_style === 'string' || config.td_style instanceof String) ? config.td_style : '';
        this.icon = config.icon && (typeof config.icon === 'string' || config.icon instanceof String) ? config.icon : '';
        this.color = config.color && (typeof config.color === 'string' || config.color instanceof String) ? config.color : '';
        this.title = config.title && (typeof config.title === 'string' || config.title instanceof String) ? config.title : '';
        this.tooltip = config.tooltip && (typeof config.tooltip === 'string' || config.tooltip instanceof String) ? config.tooltip : '';
        this.grayed = config.grayed && (typeof config.grayed === 'boolean' || config.grayed instanceof Boolean) ? config.grayed : false;
        this.selected = config.selected && (typeof config.selected === 'boolean' || config.selected instanceof Boolean) ? config.selected : false;
        this.checkboxFieldWidth = config.checkboxFieldWidth || '';
    }

    getType() {
        return this.type;
    }

    getTypeaction() {
        return this.typeaction;
    }

    getClass() {
        return this.class;
    }

    getStyle(): { [key: string]: string } {
        return this.parseStyle(this.style);
    }

    getTdClass() {
        return this.td_class;
    }

    getTdStyle(): { [key: string]: string } {
        return this.parseStyle(this.td_style);
    }
      

    getIcon() {
        return this.icon;
    }

    getColor() {
        return this.color;
    }

    getTitle(): string {
        return this.title;
    }

    getTooltip() {
        return this.tooltip;
    }

    getGrayed() {
        return this.grayed;
    }

    getSelected() {
        return this.selected;
    }

    getCheckboxFieldWidth(): { [key: string]: string } {
        return this.parseStyle(this.checkboxFieldWidth);
    }
    private parseStyle(styleString: string): { [key: string]: string } {
        if (!styleString) {
            return {};
        }

        return styleString
            .split(';')
            .filter((style) => style.includes(':'))
            .reduce((styleObj, style) => {
                const [key, value] = style.split(':').map((s) => s.trim());
                if (key && value) {
                    styleObj[key] = value;
                }
                return styleObj;
            }, {} as { [key: string]: string });
    }
}
